<template>
  <div>
      <div class="d-flex justify-content-between flex-row-column">
      <headnavigation :flow="flow" />

      <span class="r-width-100 d-inline-block mr-3">
        <md-field>
          <label for="lmt_id">Show all Red Flags</label>
          <md-select
            v-on:input="filterResults($event,'user_type')"
            name="user_type"
            id="user_type"
            v-model="user_type"
          >
            <md-option value="1">Show All</md-option>
            <md-option value="2">{{ $t('lmt_specific.only_lmt_red_flags') }}</md-option>
            <md-option value="3">{{ $t('agent_specific.only_agents_red_flags') }}</md-option>
          </md-select>
        </md-field>
      </span>
    </div>
    <hr class="hr-line" />
    <md-table
      :md-sort-fn="orderBy"
       v-show="!loading"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      v-if="items.length>0"
      v-model="items"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Date Created" md-sort-by="created_at">{{ item.created_at }}</md-table-cell>
        <md-table-cell md-label="Type" md-sort-by="type">{{ item.type }}</md-table-cell>
        <md-table-cell :md-label="$t('general.agent_id')" md-sort-by="agent_id">{{ item.agent_id }}</md-table-cell>
               <md-table-cell md-label="Red Flag" md-sort-by="red_flag">{{ item.red_flag }}</md-table-cell>
        <md-table-cell md-label="Details" md-sort-by="address">
          <router-link :to="'/bank/red-flags/details/'+item.id">See Details</router-link>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items.length>0&&pagination"
      :meta="pagination.meta"
      :links="pagination.links"
      :per_page="per_page"
    />

    <empty-state v-if="!loading&&items.length==0" />

    <loading v-if="loading" />

    <confirm type="user" v-if="confirm" @cancel="onCancel" @confirm="onConfirm" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// import CRUD methods for users
import Users from "../../../mixins/users.js";

// Confirmation component before deleting user
import ConfirmDelete from "../../../components/owner/ConfirmDelete";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";

export default {
  mixins: [Pagination, Users, DataMixin],
  components: {
    confirm: ConfirmDelete
  },
  data() {
    return {
      flow: [
        { text: "Red Flags", link: "/bank/red-flags" },
        { text: "" }
      ],
      search_term: "",
      // url for loading data
      api_url: "/red-flags/lmt?bank_lmt_id=" + this.$route.params.bank_lmt_id,
      //IMPORTANT loaded data is stored in items
      items: [],
      myID: auth.getID(),
      user_type:''
    };
  },
  created() {
    this.loadData();
    this.loadInitalData();
  },
  methods: {
    loadInitalData() {
      axios
        .get(this.api_url)
        .then(({ data }) => {
          this.flow[1].text=data.bank_lmt.lmt.name;
        })
        .catch(error => {
          //this.$router.push("/owner/agents");
        });
    }
  }
};
</script>